import {createRootContextHook} from 'common/util/react';

export const useBehaviors = createRootContextHook(`behaviors`);
